{
  "$schema": "https://mux.run/theme.json",
  "name": "Synthwave '84",
  "id": "synthwave84",
  "light": {
    "palette": {
      "neutral": "#fafafa",
      "ink": "#262335",
      "primary": "#00bcd4",
      "accent": "#9c27b0",
      "success": "#4caf50",
      "warning": "#ff9800",
      "error": "#f44336",
      "info": "#ff5722"
    },
    "overrides": {
      "text-weak": "#5c5c8a",
      "syntax-comment": "#5c5c8a",
      "syntax-keyword": "#e91e63",
      "syntax-string": "#ff9800",
      "syntax-primitive": "#ff5722",
      "syntax-variable": "#262335",
      "syntax-property": "#9c27b0",
      "syntax-type": "#00bcd4",
      "syntax-constant": "#9c27b0",
      "syntax-operator": "#e91e63",
      "syntax-punctuation": "#262335",
      "syntax-object": "#262335",
      "markdown-heading": "#e91e63",
      "markdown-text": "#262335",
      "markdown-link": "#00bcd4",
      "markdown-link-text": "#9c27b0",
      "markdown-code": "#4caf50",
      "markdown-block-quote": "#5c5c8a",
      "markdown-emph": "#ff9800",
      "markdown-strong": "#ff5722",
      "markdown-horizontal-rule": "#e0e0e0",
      "markdown-list-item": "#00bcd4",
      "markdown-list-enumeration": "#9c27b0",
      "markdown-image": "#00bcd4",
      "markdown-image-text": "#9c27b0",
      "markdown-code-block": "#262335"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#262335",
      "ink": "#ffffff",
      "primary": "#36f9f6",
      "accent": "#b084eb",
      "success": "#72f1b8",
      "warning": "#fede5d",
      "error": "#fe4450",
      "info": "#ff8b39",
      "diffAdd": "#97f1d8",
      "diffDelete": "#ff5e5b"
    },
    "overrides": {
      "text-weak": "#848bbd",
      "syntax-comment": "#848bbd",
      "syntax-keyword": "#ff7edb",
      "syntax-string": "#fede5d",
      "syntax-primitive": "#ff8b39",
      "syntax-variable": "#ffffff",
      "syntax-property": "#b084eb",
      "syntax-type": "#36f9f6",
      "syntax-constant": "#b084eb",
      "syntax-operator": "#ff7edb",
      "syntax-punctuation": "#ffffff",
      "syntax-object": "#ffffff",
      "markdown-heading": "#ff7edb",
      "markdown-text": "#ffffff",
      "markdown-link": "#36f9f6",
      "markdown-link-text": "#b084eb",
      "markdown-code": "#72f1b8",
      "markdown-block-quote": "#848bbd",
      "markdown-emph": "#fede5d",
      "markdown-strong": "#ff8b39",
      "markdown-horizontal-rule": "#495495",
      "markdown-list-item": "#36f9f6",
      "markdown-list-enumeration": "#b084eb",
      "markdown-image": "#36f9f6",
      "markdown-image-text": "#b084eb",
      "markdown-code-block": "#ffffff"
    }
  }
}
